<template>
    <div class="pmtdiv">
        <smallbutton :toplabel="title" @click="startAdd()" v-if="showButton" :buttonclass="buttonClass" :disabled="disabled"/>
        <linkbutton :toplabel="title" @click="startAdd()" v-if="!showButton"/>
        <!--  MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform">
                    <label class="titlelabel">{{title}}</label>
                    <br/>
                    <div class="entry">    
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="amtfield">Amount $</label>
                            <label class="required">*</label>
                        </div>
                        <input id="amtfield" class="entryText capital" type="currency"  name="" ref="amtfield" required="true" v-model="amount"
                            @focus="$event.target.select()" >
                        
                    </div>
            
                    
                    <smallbutton  @click="Save()" toplabel="Save" buttonclass="button buttonsave"/>
                    
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" buttonclass="button buttoncancel"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
                    
                </form>
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import pos from '../../services/pos.js'
    import pos_culinary from '../../services/pos_culinary.js'
    export default {
        name:'addtip',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },
          
            defaultAmount:{
                type:Number,
                default:0,
            },

            buttonClass:{
                type:String,
                default:'button buttonpay'
            },


            disabled:{
                type:Boolean,
                default:false
            },
            guestNum:{
                tyype:String,
                default:null
            }
            
        },
        mixins:[format,pos,pos_culinary],
        data(){
            return{
                title:'Add Tip',
                amount:0,
                guestNumber:null
                
            }
        },
     
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait'
            ]),

        },
        methods:{
           
            startAdd(){
                this.responseMessage=null
                this.guestNumber=this.guestNum
                this.amount = 0
                this.$refs.mymodal.openModal()
                this.$nextTick(()=>{
                    this.$refs.amtfield.focus()
                });
            },
            Save(){
               this.addTip(this.amount)
                this.$refs.mymodal.closeModal()
            },

        }
    }
    </script>
    
    <style>

    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    